import { api } from "./auth";
import { PROGRAMS } from "../data/programData";

// Deep clone the seed so the original export is never mutated.
const cloneSeed = () => JSON.parse(JSON.stringify(PROGRAMS));

/**
 * Load programs: fetch overrides from DB, merge onto seed data.
 * Returns array of program objects (same shape as before).
 */
export async function loadPrograms() {
  const base = cloneSeed();
  try {
    const res = await api.get("/sub-kegiatan-overrides");
    const overrides = res.data || {};
    // Merge overrides onto seed
    return base.map((p) => ({
      ...p,
      subKegiatan: p.subKegiatan.map((s) => {
        const ov = overrides[s.id];
        if (!ov) return s;
        return {
          ...s,
          status: ov.status ?? s.status,
          progress: ov.progress ?? s.progress,
          catatan: ov.catatan ?? s.catatan,
          targetMulai: ov.targetMulai ?? s.targetMulai,
          targetSelesai: ov.targetSelesai ?? s.targetSelesai,
          prioritas: ov.prioritas ?? s.prioritas,
        };
      }),
    }));
  } catch (err) {
    console.warn("programStorage: gagal fetch overrides, fallback ke seed.", err);
    return base;
  }
}

/**
 * Persist a single sub-kegiatan override to the DB.
 */
export async function saveSubKegiatanAPI(subId, patch) {
  return api.patch(`/sub-kegiatan/${subId}`, patch);
}

// Update a single sub-kegiatan (by id) across the program list (in-memory only).
export function updateSubKegiatan(programs, subId, patch) {
  return programs.map((p) => ({
    ...p,
    subKegiatan: p.subKegiatan.map((s) => (s.id === subId ? { ...s, ...patch } : s)),
  }));
}

// ---------- Derivations ----------
export function flattenSubs(programs) {
  return programs.flatMap((p) =>
    p.subKegiatan.map((s) => ({ ...s, programKode: p.kode, programNama: p.nama })),
  );
}

export function programProgress(program) {
  const subs = program.subKegiatan;
  if (subs.length === 0) return { percent: 0, done: 0, total: 0 };
  const done = subs.filter((s) => s.status === "SELESAI").length;
  const percent = Math.round((done / subs.length) * 100);
  return { percent, done, total: subs.length };
}

// Aggregate program status for the main row badge.
export function programRollupStatus(program) {
  const subs = program.subKegiatan;
  if (subs.length === 0) return "BELUM_MULAI";
  if (subs.some((s) => s.status === "TERHAMBAT")) return "TERHAMBAT";
  if (subs.every((s) => s.status === "SELESAI")) return "SELESAI";
  if (subs.some((s) => s.status === "ON_PROGRESS" || s.status === "SELESAI"))
    return "ON_PROGRESS";
  return "BELUM_MULAI";
}

export function summarize(programs) {
  const all = flattenSubs(programs);
  const count = (st) => all.filter((s) => s.status === st).length;
  return {
    total: all.length,
    selesai: count("SELESAI"),
    onProgress: count("ON_PROGRESS"),
    belumMulai: count("BELUM_MULAI"),
    terhambat: count("TERHAMBAT"),
  };
}
